import { Laya3DRender } from "../../d3/RenderObjs/Laya3DRender";
import { LayaGL } from "../../layagl/LayaGL";
import { StatElement } from "../../layagl/StatisticsContext";
import { Browser } from "../../utils/Browser";
import { FastSinglelist } from "../../utils/SingletonList";
import { RenderQuickSort } from "./RenderQuickSort";
export class RenderListQueue {
    get elements() { return this._elements; }
    constructor(isTransParent) {
        this._elements = new FastSinglelist();
        this._isTransparent = isTransParent;
        this._quickSort = new RenderQuickSort();
        this._batch = Laya3DRender.Render3DPassFactory.createInstanceBatch();
    }
    addRenderElement(renderelement) {
        renderelement.materialShaderData && this._elements.add(renderelement);
    }
    _batchQueue() {
        if (!this._isTransparent) {
            let time = Browser.now();
            this._batch.batch(this._elements);
            LayaGL.statAgent.recordTimeData(StatElement.T_3DBatchTime, Browser.now() - time);
        }
    }
    renderQueue(context) {
        this._batchQueue();
        const count = this._elements.length;
        this._quickSort.sort(this._elements, this._isTransparent, 0, count - 1);
        context.drawRenderElementList(this._elements);
        LayaGL.statAgent.recordCTData(this._isTransparent ? StatElement.CT_TransDrawCall : StatElement.CT_OpaqueDrawCall, this.elements.length);
        this._batch.clearRenderData();
    }
    clear() {
        this._elements.elements.fill(null);
        this._elements.length = 0;
    }
    destroy() {
        this.clear();
        this._elements = null;
    }
}
